import {getUUID} from '@yandex-delivery/utils'
import {appConfig} from 'src/shared/config'
import {
  DeliveryType,
  DestinationPointDeliveryMethod,
  type Order as FormValues,
} from 'src/shared/types'
import {toDestinationPoints} from 'src/shared/utils/to-destination-point'

import {toSourcePoint, withCorrectPointContact} from './lib'

// fixme нужно убрать прямой кастинг, это выстрел в колено
export function getDefaultValues(): FormValues {
  const sddClaimInfo = undefined // в ЛК приходит с бекенда
  const isCard = true // clientType === 'card'
  const sourcePoint = toSourcePoint(sddClaimInfo, isCard)
  sourcePoint.contact = withCorrectPointContact(sourcePoint, appConfig.launch)
  sourcePoint.address.coordinates = appConfig.location

  return {
    sourcePoint,
    deliveryType: DeliveryType.Express,
    isBusiness: false,
    destinationPoints: toDestinationPoints(
      sddClaimInfo,
      isCard,
      DestinationPointDeliveryMethod.PickUpPoint,
    ),
    offerId: getUUID(),
    ndd: {
      deliveryDate: undefined,
    },
    offerFlow: {
      isPending: false,
      vertical: undefined,
      id: undefined,
      version: undefined,
    },
    __settings: {
      __sddClaim: sddClaimInfo,
    },
  } as FormValues
}
